var render = function render(){var _vm=this,_c=_vm._self._c;return _c('panel-item',{attrs:{"grid":"","label":_vm.label,"narrow":_vm.narrow,"narrow-from":_vm.narrowFrom,"underline":""}},[_c('status-tag',{attrs:{"status":_vm.value}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }